<form
  [formGroup]="form"
  [patchForm]="employeeBooking"
  (ngSubmit)="onFormSubmit()"
>
  <div class="mb-4">
    <div class="mb-4">
      <div class="d-flex mb-1">
        <label id="typeId" class="form-label">
          {{ 'general.type' | translate }}
          <small>({{ 'general.required' | translate | lowercase }})</small>
        </label>
      </div>

      <select
        aria-labelledby="typeId"
        aria-describedby="type"
        formControlName="type"
        class="form-select"
        required
        [attr.aria-invalid]="
          form.controls.type.dirty && form.controls.type.invalid ? 'true' : null
        "
      >
        <option [ngValue]="null" selected>
          {{ 'general.select' | translate }}
        </option>
        <option *ngFor="let type of bookingTypes$ | async" [ngValue]="type">
          {{ 'employeeModule.bookingType' + type | translate }}
        </option>
      </select>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="type"
        role="alert"
        *ngIf="form.controls.type.dirty && form.controls.type.invalid"
      >
        {{ 'general.type' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div
      *ngIf="form.value.type != employeeBookingTypes.UNAVAILABLE"
      class="mb-4"
    >
      <label id="productId" class="form-label">
        {{ 'productModule.product' | translate }}
        <small>({{ 'general.required' | translate | lowercase }})</small>
      </label>

      <select
        aria-labelledby="productId"
        aria-describedby="product product2"
        formControlName="productId"
        class="form-select"
        required
        [attr.aria-invalid]="
          form.controls.productId.dirty && form.controls.productId.invalid
            ? 'true'
            : null
        "
      >
        <option [ngValue]="null" selected>
          {{ 'general.select' | translate }}
        </option>
        <option
          *ngFor="let product of availableProductsForEmployee$ | async"
          [ngValue]="product.id"
        >
          {{ product.id | getTranslation: 'product' : 'description' | async }}
        </option>
      </select>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="product"
        role="alert"
        *ngIf="form.controls.productId.dirty && form.controls.productId.invalid"
      >
        {{ 'productModule.product' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="product2"
        role="alert"
        *ngIf="
          !(isLoading$ | async) &&
          !(availableProductsForEmployee$ | async)?.length &&
          form.value.type != employeeBookingTypes.UNAVAILABLE
        "
      >
        {{ 'myWorkModule.thereAreNoAvailableProducts' | translate }}
      </p>
    </div>

    <div class="row mb-4">
      <div class="col-sm-6 mb-2 mb-sm-0">
        <label class="form-label" id="startTimeLabel">
          {{ 'general.startTime' | translate }}
          <small>({{ 'general.required' | translate | lowercase }})</small>
        </label>

        <datetime-input
          aria-describedby="starDate starDate2"
          aria-labelledby="startTimeLabel"
          formControlName="startDate"
          required
          [isDisabled]="!(employeeBookingConfig$ | async)?.startTimeEditable"
        ></datetime-input>

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="starDate"
          role="alert"
          *ngIf="
            form.controls.startDate.dirty && form.controls.startDate.invalid
          "
        >
          {{ 'general.startTime' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="starDate2"
          role="alert"
          *ngIf="contractIsNotValidOnStartDate"
        >
          {{ 'employeeModule.contractIsNotValidOnStartDate' | translate }}
        </p>
      </div>
      <div class="col-sm-6 mb-2 mb-sm-0">
        <label class="form-label" id="endTimeLabel">
          {{ 'general.endTime' | translate }}
          <small>({{ 'general.required' | translate | lowercase }})</small>
        </label>

        <datetime-input
          aria-describedby="endDate endDate2"
          aria-labelledby="endTimeLabel"
          formControlName="endDate"
          required
          [isDisabled]="!(employeeBookingConfig$ | async)?.endTimeEditable"
        ></datetime-input>

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="endDate"
          role="alert"
          *ngIf="form.controls.endDate.dirty && form.controls.endDate.invalid"
        >
          {{ 'general.endTime' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="endDate2"
          role="alert"
          *ngIf="contractIsNotValidOnEndDate"
        >
          {{ 'employeeModule.contractIsNotValidOnEndDate' | translate }}
        </p>
      </div>
    </div>

    <div
      *ngIf="form.value.type != employeeBookingTypes.UNAVAILABLE"
      class="mb-4"
    >
      <label id="contractId" class="form-label">
        {{ 'employeeModule.contract' | translate }}
        <small>({{ 'general.required' | translate | lowercase }})</small>
      </label>

      <select
        aria-labelledby="contractId"
        aria-describedby="contract"
        formControlName="contractId"
        class="form-select"
        required
        [attr.aria-invalid]="
          form.controls.contractId.dirty && form.controls.contractId.invalid
            ? 'true'
            : null
        "
      >
        <option [ngValue]="null" selected>
          {{ 'general.select' | translate }}
        </option>
        <option
          *ngFor="let contract of contracts$ | async"
          [ngValue]="contract.id"
        >
          {{ contract.description }}
        </option>
      </select>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="contract"
        role="alert"
        *ngIf="
          form.controls.contractId.dirty && form.controls.contractId.invalid
        "
      >
        {{ 'employeeModule.contract' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div
      *ngIf="
        form.value.type != employeeBookingTypes.UNAVAILABLE &&
        (employeeBookingConfig$ | async)?.descriptionVisible
      "
      class="mb-4"
    >
      <label class="form-label" id="EmpDescriptionId">
        {{ 'general.description' | translate }}
        <small *ngIf="(employeeBookingConfig$ | async)?.descriptionRequired">
          ({{ 'general.required' | translate | lowercase }})
        </small>
      </label>
      <textarea
        autofocus
        class="form-control"
        type="text"
        formControlName="description"
        [readonly]="!(employeeBookingConfig$ | async)?.descriptionEditable"
        rows="4"
        aria-labelledby="EmpDescriptionId"
        aria-describedby="description"
        [required]="(employeeBookingConfig$ | async)?.descriptionRequired"
        [attr.aria-invalid]="
          form.controls.description.dirty && form.controls.description.invalid
            ? 'true'
            : null
        "
      >
      </textarea>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="description"
        role="alert"
        *ngIf="
          form.controls.description.dirty && form.controls.description.invalid
        "
      >
        {{ 'general.description' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <!--  -->
    <div
      *ngIf="
        form.value.type != employeeBookingTypes.UNAVAILABLE &&
        (employeeBookingConfig$ | async)?.additionalInfoVisible
      "
      class="mb-4"
    >
      <label class="form-label" id="memoId">
        {{ 'general.memo' | translate }}
        <small *ngIf="(employeeBookingConfig$ | async)?.additionalInfoRequired">
          ({{ 'general.required' | translate | lowercase }})
        </small>
      </label>
      <textarea
        autofocus
        class="form-control"
        type="text"
        formControlName="memo"
        [readonly]="!(employeeBookingConfig$ | async)?.additionalInfoEditable"
        rows="4"
        aria-labelledby="memoId"
        aria-describedby="memo"
        [required]="(employeeBookingConfig$ | async)?.additionalInfoRequired"
        [attr.aria-invalid]="bookingIsAlreadyChecked ? 'true' : null"
      >
      </textarea>
    </div>
  </div>

  <p
    class="invalid-feedback"
    aria-atomic="true"
    id="memo"
    role="alert"
    *ngIf="bookingIsAlreadyChecked"
  >
    {{ 'employeeModule.bookingAlreadyChecked' | translate }}
  </p>

  <div
    class="confirm-cancellation-area mb-4"
    *ngIf="form.value.type != employeeBookingTypes.UNAVAILABLE && showConfirm"
  >
    <p>
      {{ 'employeeModule.bookingCancellationCustomMessage' | translate }}
    </p>

    <form [formGroup]="messageForm">
      <div>
        <input
          attr.aria-label="{{ 'wcag.bookingCancellationMessage' | translate }}"
          autofocus
          class="form-control"
          type="text"
          inputmode="text"
          formControlName="message"
        />
      </div>
    </form>
  </div>

  <div class="d-flex justify-content-end">
    <button
      type="button"
      *ngIf="shouldShowCancelButton$() | async"
      class="btn btn-soft-primary"
      (click)="cancelEmployeeBooking()"
    >
      {{ 'bookingModule.cancelBooking' | translate }}
    </button>

    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="
        disableSaveButton ||
        !form.dirty ||
        bookingIsAlreadyChecked ||
        (!(isLoading$ | async) &&
          !(availableProductsForEmployee$ | async)?.length &&
          form.value.type != employeeBookingTypes.UNAVAILABLE)
      "
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
